<div #overlay id="modalTalent" class="modal fade" [ngClass]="{ 'show' : visible }" role="dialog" style="display: block;"
    (click)="fastEventKilling($event)">
    <div id="{{dialogId || ''}}" class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div style="display:flex; flex-direction:row; flex-wrap:nowrap;">
                  @if (title) {
                    <h5 class="modal-title">{{title}}</h5>
                  }

                  <button style="margin-top: -20px; margin-left:auto;" type="button" class="close"
                      data-bs-dismiss="modal" aria-label="Close" (click)="close($event)">
                      <span aria-hidden="true">×</span>
                  </button>
                </div>
            </div>
            <div class="modal-body">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
